/**
 * 产品变体SKU自动更新脚本
 * 监听变体切换事件，自动更新产品SKU显示
 * 避免修改核心文件，确保主题升级时不被覆盖
 */

(function() {
  'use strict';

  // 确保在DOM加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSkuUpdate);
  } else {
    initVariantSkuUpdate();
  }

  let variantChangeUnsubscriber = undefined;

  function initVariantSkuUpdate() {
    // 检查必要的依赖是否存在
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      console.warn('variant-sku-update: PUB_SUB_EVENTS or subscribe function not found');
      return;
    }

    // 订阅变体切换事件
    variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
  }

  function handleVariantChange(event) {
    if (!event || !event.data || !event.data.variant) {
      return;
    }

    const variant = event.data.variant;
    const sectionId = event.data.sectionId;

    // 更新所有相关的SKU元素
    updateSkuElements(sectionId, variant);

    // 如果没有sectionId，尝试从当前页面的variant-selects元素获取
    if (!sectionId) {
      const variantSelects = document.querySelector('variant-selects');
      if (variantSelects && variantSelects.dataset.section) {
        updateSkuElements(variantSelects.dataset.section, variant);
      }
    }
  }

  function updateSkuElements(sectionId, variant) {
    if (!sectionId || !variant) return;

    // 更新主要SKU显示（产品价格块中的SKU）
    const productSkuElement = document.getElementById(`ProductSku-${sectionId}`);
    if (productSkuElement) {
      if (variant.sku && variant.sku.trim() !== '') {
        productSkuElement.innerHTML = `SKU: ${variant.sku}`;
        productSkuElement.style.display = '';
      } else {
        // SKU为空时隐藏元素或显示空值
        productSkuElement.innerHTML = 'SKU: ';
        productSkuElement.style.display = 'none';
      }
    }
  }

  // 页面卸载时取消订阅
  window.addEventListener('beforeunload', function() {
    if (variantChangeUnsubscriber) {
      variantChangeUnsubscriber();
    }
  });
})();

